import React, {useCallback, useEffect, useState} from 'react';
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {Message} from "primereact/message";

import {SellerWorkspaceService} from "../../service/SellerWorkspaceService";
import {formatCount, formatGap} from "./sellerFormat";

const sellerWorkspaceService = new SellerWorkspaceService();

const headlineGrid = {display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: 12, marginBottom: 16};
const headlineCard = {border: '1px solid #e5e7eb', borderRadius: 6, padding: '12px 14px', background: 'transparent', textAlign: 'left'};

const Headline = ({value, label, onClick}) => (
    <button type="button" className="p-link" style={headlineCard} onClick={onClick}>
        <div style={{fontSize: '1.5rem', fontWeight: 700}}>{value}</div>
        <div style={{color: '#6b7280'}}>{label}</div>
    </button>
);

// Level 1: how far each marketplace's sellers are matched to the operator's own.
const MarketplaceSummary = ({t, onOpenList}) => {
    const [summary, setSummary] = useState(null);
    const [failed, setFailed] = useState(false);
    const load = useCallback(() => {
        setFailed(false);
        return sellerWorkspaceService.getSummary().then(setSummary).catch(() => setFailed(true));
    }, []);
    useEffect(() => { load(); }, [load]);

    if (failed) {
        return <div>
            <Message severity="warn" style={{display: 'block', marginBottom: 10}}
                     text={t('sellers_workspace.loadFailed', 'Satıcı bilgileri yüklenemedi.')}/>
            <Button label={t('sellers_workspace.retry', 'Tekrar dene')} className="p-button-outlined p-button-sm" onClick={load}/>
        </div>;
    }
    if (!summary) return null;

    return <div>
        <div style={headlineGrid}>
            <Headline value={formatCount(summary.own_sellers, t)} label={t('sellers_workspace.summary.ownSellers', 'Koçtaş satıcısı')}
                      onClick={() => onOpenList({})}/>
            <Headline value={formatCount(summary.linked?.trendyol ?? 0, t)} label={t('sellers_workspace.summary.linkedTrendyol', "Trendyol'da bağlı")}
                      onClick={() => onOpenList({marketplace: 'trendyol'})}/>
            <Headline value={formatCount(summary.linked?.hepsiburada ?? 0, t)} label={t('sellers_workspace.summary.linkedHepsiburada', "Hepsiburada'da bağlı")}
                      onClick={() => onOpenList({marketplace: 'hepsiburada'})}/>
            <Headline value={formatCount(summary.pending_suggestions, t)} label={t('sellers_workspace.summary.pending', 'Onay bekleyen öneri')}
                      onClick={() => onOpenList({filter: 'suggestions'})}/>
        </div>
        <DataTable value={summary.marketplaces} dataKey="key" responsiveLayout="scroll"
                   emptyMessage={t('sellers_workspace.summary.empty', 'Henüz pazaryeri verisi yok.')}>
            <Column header={t('sellers_workspace.summary.marketplace', 'Pazaryeri')}
                    body={(row) => <Button label={row.label} className="p-button-link" style={{padding: 0}}
                                           onClick={() => onOpenList({marketplace: row.key})}/>}/>
            <Column header={t('sellers_workspace.summary.known', 'Bilinen satıcı')} body={(row) => formatCount(row.known, t)}/>
            <Column header={t('sellers_workspace.summary.linked', 'Koçtaş satıcısıyla bağlı')} body={(row) => formatCount(row.linked, t)}/>
            <Column header={t('sellers_workspace.summary.suggested', 'Öneri')} body={(row) => formatCount(row.suggested, t)}/>
            <Column header={t('sellers_workspace.summary.unmatched', 'Eşleşmedi')} body={(row) => formatCount(row.unmatched, t)}/>
            <Column header={t('sellers_workspace.summary.medianGap', 'Aynı satıcı, medyan fiyat farkı')}
                    body={(row) => <span>
                        {formatGap(row.median_gap, t)}
                        {row.unreviewed > 0 &&
                            <small style={{color: '#6b7280', marginLeft: 6}}>
                                {t('sellers_workspace.summary.unreviewed', '{{count}} eşleşme incelenmedi', {count: row.unreviewed})}
                            </small>}
                    </span>}/>
        </DataTable>
        <p style={{color: '#6b7280', marginTop: 10}}>
            {t('sellers_workspace.summary.note', '"Bilinen satıcı" izlediğimiz ürünlerde görülen veya aramayla bulunan satıcıdır, pazaryerinin toplam satıcısı değildir. Fiyat farkı yalnız bağlı satıcıların izlenen ürünlerinden hesaplanır.')}
        </p>
    </div>;
};

export default MarketplaceSummary;
